export default {
    state:{
        payWay:"",
        recipeSelection:[],
        wxzfInput:{},
        wxzfOutput:{},
        payInput:{},
        payOutput:{},
        
    },
    actions: {
        changeWxzfInput:(context,para)=>{
            context.commit('changeWxzfInput',para)
        },

        changeWxzfOutput:(context,para)=>{
            context.commit('changeWxzfOutput',para)
        },

        changeRecipeSelection:(context,para)=>{
            context.commit('SET_RecipeSelection',para)
        },

        changePayInput:(context,para)=>{
            context.commit('changePayInput',para)
        },

        changePayOutput:(context,para)=>{
            context.commit('changePayOutput',para)
        },

        clearPayStore:(context)=>{
            context.commit('clearPayStore')
        },
    },
    mutations: {
        changeWxzfInput:(state,para)=>{
            state.wxzfInput =   para  
        },

        changeWxzfOutput:(state,para)=>{
            state.wxzfOutput =   para  
        },

        SET_RecipeSelection:(state,para)=>{
            state.recipeSelection =   para  
        },

        changePayInput:(state,para)=>{
            state.payInput =   para  
        },

        changePayOutput:(state,para)=>{
            state.payOutput =   para  
        },

        clearPayStore:(state)=>{
            state.wxzfInput =   {}  
            state.wxzfOutput =   {} 
            state.recipeSelection = []
            state.payWay = ""
            state.payOutpiut = {}
            state.payInput =  {}
        }
    }
}